import { Section, SlateUtils } from '@all-hands-hq/plex-graphql-schema';
import { useEffect } from 'react';

import { GetDocumentToImportQuery } from '../../../../graphql/gen/types';
import { DocumentToImportAction } from './documentToImportReducer';

export const useInitializeDocumentToImportOnSuccess = ({
  data,
  dispatch,
  headingIds,
}: {
  data: GetDocumentToImportQuery | undefined;
  dispatch: React.Dispatch<DocumentToImportAction>;
  headingIds?: string[];
}): void => {
  useEffect(() => {
    if (
      data?.linkMetadata.details.__typename === 'GoogleDocLinkMetadata' &&
      data.linkMetadata.details.document?.__typename === 'GoogleDoc' &&
      data.linkMetadata.details.fileMetadata != null
    ) {
      const { title, content } = data.linkMetadata.details.document;

      const document: Section = {
        startIndex: -1,
        endIndex: content.length,
        children: SlateUtils.documentOutline(content),
        parent: null,
        level: 0,
        title: { type: 'paragraph', children: [{ text: title }] },
      };
      document.children.forEach((child) => {
        child.parent = document;
      });

      const documentSections = Section.getDescendentsInclusive(document);

      dispatch({
        type: 'INIT',
        state: {
          document,
          content,
          selectedSections:
            headingIds != null
              ? new Set(
                  documentSections.filter(
                    (section) => section.title.headingId != null && headingIds.includes(section.title.headingId)
                  )
                )
              : new Set(documentSections),
          externalEntityId: data.linkMetadata.details.fileMetadata.externalEntityId,
        },
      });
    }
  }, [data, dispatch, headingIds]);
};
